<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.abbreviation')" prop="name">
        <BjInput
          v-model="form.name"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.full')" prop="logisticsName">
        <BjInput
          v-model="form.logisticsName"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompany.table.logisticsCompanyName')" prop="companyId">
        <BjSelectLogisticCompany
          v-model="form.companyId"
          :default-options="{
            label: form.companyName,
            value: form.companyId,
          }"
          clearable
        />
      </el-form-item>
    </el-col>

    <!-- 新增字段 -->
    <!-- <el-col :span="22">
      <el-form-item label="Max.Weight" prop="companyId">
        <BjSelectLogisticCompany
          v-model="form.companyId"
          :default-options="{
            label: form.companyName,
            value: form.companyId,
          }"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item label="Max.Cubic Weight" prop="companyId">
        <BjSelectLogisticCompany
          v-model="form.companyId"
          :default-options="{
            label: form.companyName,
            value: form.companyId,
          }"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item label="Max.Length" prop="companyId">
        <BjSelectLogisticCompany
          v-model="form.companyId"
          :default-options="{
            label: form.companyName,
            value: form.companyId,
          }"
          clearable
        />
      </el-form-item>
    </el-col> -->

    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.priority')" prop="sortNum">
        <el-input-number
          v-model="form.sortNum"
          :maxlength="MAX_LENGTH.DEFAULT"
          :min="0"
          :max="MAX_LENGTH.PRIORITY"
          :precision="0"
          :controls="false"
        />
        <span class="text-muted font12 ml0">{{ $t('businessLogisticsCompanyBusiness.dialog.priorityMessage') }}</span>
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.maxL')" prop="maxLength">
        <BjInputNumber
          v-model="form.maxLength"
          :min="1"
          :max="1000"
          :precision="2"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        >
          <template #append>cm</template>
        </BjInputNumber>
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.maxW')" prop="maxWeight">
        <BjInputNumber
          v-model="form.maxWeight"
          :min="1"
          :max="1000"
          :precision="2"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        >
          <template #append>kg</template>
        </BjInputNumber>
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.maxVw')" prop="maxCubicWeight">
        <BjInputNumber
          v-model="form.maxCubicWeight"
          :min="1"
          :max="1000"
          :precision="2"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
          clearable
        >
          <template #append>kg</template>
        </BjInputNumber>
      </el-form-item>
    </el-col>
    <!-- <el-col v-if="!isEdit" :span="22">
      <el-form-item label="启用" prop="enableFlag">
        <el-switch v-model="form.enableFlag" :active-value="true" :inactive-value="false" />
      </el-form-item>
    </el-col> -->
  </BjDrawerForm>
</template>
<script>
import { logisticApi } from '@/api';

const getDefaultForm = () => {
  return {
    companyId: null,
    enableFlag: true,
    id: null,
    sortNum: 1,
    name: null,
    logisticsName: null,
    objectVersionNumber: null,
    maxLength: 1,
    maxWeight: 1,
    maxCubicWeight: 1,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      // 表单校验
      const rules = {
        name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        logisticsName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        enableFlag: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        companyId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        sortNum: [{ required: true, message: this.$t('businessLogisticsCompanyBusiness.dialog.priorityRulesMsg'), trigger: 'blur' }],
        maxLength: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        maxWeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        maxCubicWeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
      return rules;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('businessLogisticsCompany.common.editBusiness') : this.$t('businessLogisticsCompany.common.addBusiness'));

      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    toNumber(obj) {
      obj.maxLength = Number(obj.maxLength);
      obj.maxWeight = Number(obj.maxWeight);
      obj.maxCubicWeight = Number(obj.maxCubicWeight);
      return obj;
    },
    addApi(API_DATA) {
      const params = this.toNumber(API_DATA);
      logisticApi.addLogisticsBusiness(params).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      const params = this.toNumber(API_DATA);
      logisticApi.updateLogisticsBusiness(params).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
